/* eslint-disable no-unused-vars */
import { useState, useCallback, useMemo } from 'react';
import { replaceNumberInUrl, redirectToOldPlatformUrl, getIsLocalHost } from 'utils';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { logout } from 'store/auth/auth';
import { routes } from 'config';

const pathPatterns = [
  { pattern: /^\/Discovery(\/|$)/, id: 'campaign' },
  { pattern: /^\/manage_apps(\/|$)/, id: 'manageApps' },
  { pattern: /^\/dashboard(\/|$)/, id: 'dashboard' },
  { pattern: /^\/reports(\/|$)/, id: 'reports' },
];

const myLocation = (pathname) => {
  const match = pathPatterns.find(({ pattern }) => pattern.test(pathname));
  if (match) {
    const redirectTo = routes.list.find((route) => route.id === match.id)?.url;
    return redirectTo;
  }
};

export const useFacade = (newValue = []) => {
  const [searchInputFocus, setSearchInputFocus] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const dispatch = useDispatch();
  const current_pb_number = useSelector((state) => state.auth.pb_number);

  const foundedUsers = useMemo(
    () =>
      newValue.filter(({ pb_company, pb_email }) => {
        const fullName = pb_company?.toLowerCase();
        const email = pb_email?.toLowerCase();
        return (
          fullName.includes(searchValue.toLowerCase()) || email.includes(searchValue.toLowerCase())
        );
      }),
    [searchValue, newValue],
  );

  const handleClearSearchValue = useCallback(() => {
    setSearchValue('');
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  //i don't use it
  const handleClick = useCallback((user) => {
    const isLocalHost = getIsLocalHost();
    if (isLocalHost) {
      const newPrefix = user.pb_number;
      const oldPrefix = current_pb_number;
      const { href } = window.location;
      const newHref = href.replace(oldPrefix, newPrefix);
      //window.location.href = newHref;
      //window.open(newHref, '_blank');
    } else {
      const dashboardUrl = redirectToOldPlatformUrl(`/Dashboard.aspx`);
      const newDomain = replaceNumberInUrl(dashboardUrl, user.pb_number);
      //console.log({ newDomain });
      //window.open(newDomain, '_blank');
    }
  }, []);

  const getPublisherLink = (pb_number) => {
    const isLocalHost = getIsLocalHost();

    if (isLocalHost || window.NO_REDIRECT_TO_OLD_PLATFORM) {
      const newPrefix = pb_number;
      const oldPrefix = current_pb_number;
      // const { href } = window.location;
      // const newHref = href.replace(oldPrefix, newPrefix);
      const { origin } = window.location;
      const newHref = origin.replace(oldPrefix, newPrefix) + '/';
      return newHref;
    } else {
      const dashboardUrl = redirectToOldPlatformUrl(`/Dashboard.aspx`);
      const newDomain = replaceNumberInUrl(dashboardUrl, pb_number);
      return newDomain;
    }
  };

  return {
    searchInputFocus,
    setSearchInputFocus,
    faundedUsers: foundedUsers,
    searchValue,
    setSearchValue,
    handleClearSearchValue,
    handleClick,
    getPublisherLink,
  };
};
